module.exports = __webpack_public_path__ + "img/calm.f80226e8.jpg";